import "./styles.css";
import { RacemaxApp } from "./App";

if (!("WebSocket" in window) || !("WebGL2RenderingContext" in window) || !("AudioContext" in window)) {
  document.body.innerHTML = `<main style="min-height:100vh;display:grid;place-content:center;background:#17130f;color:#fff4d0;font-family:system-ui;padding:30px;text-align:center"><h1>Racemax n'est pas compatible avec ce navigateur</h1><p>WebGL 2, WebSocket et Web Audio sont nécessaires. Essaie une version récente de Chrome, Firefox, Edge ou Safari.</p></main>`;
} else {
  new RacemaxApp();
}
